//@ts-nocheck
import {FC, useState, useEffect, useRef} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {Fail, Icon, Success, getAllCategories, getAllUnits} from '../../../../_metronic/helpers'
import {useQuery, useMutation, useQueryClient} from 'react-query'
import {Field, Form, Formik, FormikValues, FormikHelpers} from 'formik'
import Swal from 'sweetalert2'
import {useQueryResponse} from '../products-list/core/QueryResponseProvider'
import {Product, ProductFormData, initValues} from '../core/models'
import {
  createProduct,
  getAllColors,
  getAllVats,
  getProductById,
  updateProduct,
} from '../core/requests'
import {productValidationSchema} from './core/init'
import {useAuth} from '../../auth'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import CreateCategoryModal from './modals/CreateCategoryModal'
import CreateUnitModal from './modals/CreateUnitModal'
import Select from 'react-select'
import {validate} from 'webpack'
import {getCurrency} from '../../settings/preferences/GlobalParams/core/requests'

type ProductFormProps = {
  productForUpdate?: Product
  refetchProduct?: () => void
}

const ProductForm: FC<ProductFormProps> = ({productForUpdate, refetchProduct}) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const {refetch} = useQueryResponse()
  const {currentUser} = useAuth()
  const reactQuillRef = useRef()

  const checkCharacterCount = (event) => {
    const unprivilegedEditor = reactQuillRef?.current.unprivilegedEditor
    if (unprivilegedEditor.getLength() > 250 && event.key !== 'Backspace') event.preventDefault()
  }

  const {data: categories, isLoading: categoriesLoading} = useQuery('categories', getAllCategories)
  const {data: units, isLoading: unitsLoading} = useQuery('units', getAllUnits)
  const {data: currencies, isLoading: currenciesLoading} = useQuery('currencies', getCurrency)

  // const {data: vats, isLoading: vatsLoading} = useQuery('vats', getAllVats)
  // const {data: colors, isLoading: colorsLoading} = useQuery('colors', getAllColors)

  // State to store checkbox status for each category
  const [colorActive, setColorActive] = useState<boolean>(!!productForUpdate?.color)
  const [taxActive, setTaxActive] = useState(1)
  const [taxAchatActive, setTaxAchatActive] = useState('')
  const [sohwCurrency, setShowCurrency] = useState(false)
  const [showTva, setShowTva] = useState(false)
  const [showTvaVente, setShowTvaVente] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isUnitDialogOpen, setIsUnitDialogOpen] = useState(false)
  const [newCategory, setNewCategory] = useState(null)
  const [newUnit, setNewUnit] = useState(null)
  const categoryOptions =
    categories && categories.map((category) => ({value: category.id, label: category.name}))

  const unitOptions = units && units.map((unit) => ({value: unit.id, label: unit.label}))
  const currenciesOptions =
    currencies && currencies.map((currency) => ({value: currency.id, label: currency.label}))

  // const currencyOptions = [
  //   {value: 'TND', label: 'TND - DINAR tunisien'},
  //   {value: 'EUR', label: 'EUR - EURO européen'},
  //   {value: 'USD', label: 'USD - DOLAR américain'},
  // ]

  const mutation = useMutation({
    mutationFn: getAllCategories,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries('categories')
    },
  })

  const handleActionThatChangesData = async () => {
    await mutation.mutateAsync()
  }

  const UnitMutation = useMutation({
    mutationFn: getAllUnits,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries('units')
    },
  })

  const handleActionThatChangesUnitData = async () => {
    await UnitMutation.mutateAsync()
  }

  const handleOpenDialog = () => {
    setIsDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false)
  }
  const handleSave = () => {
    setIsDialogOpen(false)
  }

  const handleOpenUnitDialog = () => {
    setIsUnitDialogOpen(true)
  }

  const handleCloseUnitDialog = () => {
    setIsUnitDialogOpen(false)
  }
  const handleUnitSave = () => {
    setIsUnitDialogOpen(false)
  }

  const stripHtml = (html: string): string => {
    const regex = /(<([^>]+)>)/gi
    const newString = html.replace(regex, '')
    return newString
  }

  const toggleTva = () => {
    setShowTva(!showTva)
  }
  const toggleTvaVente = () => {
    setShowTvaVente(!showTvaVente)
  }

  useEffect(() => {
    if (currentUser) setShowCurrency(currentUser.company.isMultiCurrency)
  }, [currentUser])

  // Toggle the active status for a category
  const handleColorToggle = () => {
    setColorActive(!colorActive)
  }
  const handleTaxActiveToggle = (
    event: {target: {checked: any}},
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    const isChecked = event.target.checked
    const newTaxActive = isChecked ? 'TTC' : 'HT'
    setTaxActive(newTaxActive)
    setFieldValue('sellPriceType', newTaxActive)
  }

  const handleTaxAchatActiveToggle = (
    event: {target: {checked: any}},
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    const isChecked = event.target.checked
    const newTaxAchatActive = isChecked ? 'TTC' : 'HT'

    setTaxAchatActive(newTaxAchatActive)
    setFieldValue('priceType', newTaxAchatActive)
  }

  const newCategoryValue =
    newCategory && categoryOptions.find((category) => category.label === newCategory.name)?.value

  const newUnitValue = newUnit && unitOptions.find((unit) => unit.label === newUnit.label)?.value

  const formValues: ProductFormData = {
    typeProductId: 1,
    code: 'PRD',
    label: productForUpdate?.label || initValues.label,
    description: productForUpdate?.description || initValues.description,
    barCode: productForUpdate?.barCode || initValues.barCode,
    category: productForUpdate?.category?.id || initValues.category?.id,
    categoryId: productForUpdate?.categoryId || initValues.categoryId,
    price: productForUpdate?.price || initValues.price,
    sellPrice: productForUpdate?.sellPrice || initValues.sellPrice,
    // priceType: productForUpdate?.priceType || initValues.priceType,
    priceType: productForUpdate?.priceType || currentUser?.company?.priceType,
    // sellPriceType: productForUpdate?.sellPriceType || initValues.sellPriceType,
    sellPriceType: productForUpdate?.sellPriceType || currentUser?.company?.priceType,
    minStock: productForUpdate?.minStock || initValues.minStock,
    maxStock: productForUpdate?.maxStock || initValues.maxStock,
    unit: productForUpdate?.unit?.id || initValues.unit,
    color: productForUpdate?.color || initValues.color,
    buyingTva: productForUpdate?.buyingTva || initValues.buyingTva || currentUser?.company?.tva,
    buyingTvaTwo:
      productForUpdate?.buyingTvaTwo || initValues.buyingTvaTwo || currentUser?.company?.tvaTwo,
    buyingTvaThree:
      productForUpdate?.buyingTvaThree ||
      initValues.buyingTvaThree ||
      currentUser?.company?.tvaThree,
    sellingTva: productForUpdate?.sellingTva || initValues.sellingTva || currentUser?.company?.tva,
    sellingTvaTwo:
      productForUpdate?.sellingTvaTwo || initValues.sellingTvaTwo || currentUser?.company?.tvaTwo,
    sellingTvaThree:
      productForUpdate?.sellingTvaThree ||
      initValues.sellingTvaThree ||
      currentUser?.company?.tvaThree,
    allowManufactureEmpty:
      productForUpdate?.allowManufactureEmpty || initValues.allowManufactureEmpty,
  }
  if (currentUser && !productForUpdate) {
    formValues.priceType = currentUser?.company?.priceType
    formValues.sellPriceType = currentUser?.company?.priceType
  }

  const handleSubmit = async (values: ProductFormData) => {
    try {
      const isValid = await productValidationSchema.isValid(values)
      if (!isValid) {
        const validationErrors = await productValidationSchema
          .validate(values, {abortEarly: false})
          .catch((err) => err.inner)
        const formErrors = validationErrors.reduce((acc, curr) => {
          acc[curr.path] = curr.message
          return acc
        }, {})
        setErrors(formErrors)
        // setSubmitting(false)
        return
      }
      const formData = {
        typeProductId: 1,
        // code: values.code,
        label: values.label,
        description: values.description,
        // description: description,
        categoryId: (newCategory && newCategoryValue) || values.category,
        barCode: values.barCode,
        price: values.price,
        sellPrice: values.sellPrice,
        priceType: values.priceType,
        sellPriceType: values.sellPriceType,
        minStock: values.minStock,
        maxStock: values.maxStock,
        unitId: (newUnit && newUnitValue) || values.unit,
        color: values.color,
        vatId: values.tva,
        buyingTva: values.buyingTva,
        buyingTvaTwo: values.buyingTvaTwo,
        buyingTvaThree: values.buyingTvaThree,
        sellingTva: values.sellingTva,
        sellingTvaTwo: values.sellingTvaTwo,
        sellingTvaThree: values.sellingTvaThree,
        allowManufactureEmpty: values.allowManufactureEmpty,
      }


      if (!productForUpdate) {
        formData.code = values.code
      }
      if (!productForUpdate?.id) {
        await createProduct(formData)
        Swal.fire({
          icon: 'success',
          title: 'Succès!',
          text: 'Service créé avec succès.',
        }).then(() => {
          refetch()
          navigate(-1)
        })
      } else {
        await updateProduct(productForUpdate.id, formData)
        Swal.fire({
          icon: 'success',
          title: 'Succès!',
          text: 'Service mis à jour avec succès.',
        }).then(() => {
          refetch()
          refetchProduct && refetchProduct()
          navigate(-1)
        })
      }
    } catch (error) {
      console.error('Form submission error', error)
      Swal.fire({
        icon: 'error',
        title: 'Erreur!',
        text: 'verifier les champs du formulaire.',
      })
    } finally {
      console.log('Form submission')
      // setSubmitting(false)
    }
  }

  const handleNewCategory = (category) => {
    setNewCategory(category)
    handleActionThatChangesData()
  }

  const handleNewUnit = (unit) => {
    setNewUnit(unit)
    handleActionThatChangesData()
  }

  useEffect(() => {
    if (newCategory) {
    }
  }, [newCategory])

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <Formik
      initialValues={formValues}
      // onSubmit={handleSubmit}
      validationSchema={productValidationSchema}
    >
      {({touched, errors, values, setFieldValue, isSubmitting}) => (
        <Form>
          {isDialogOpen && (
            <CreateCategoryModal
              refetch={refetch}
              onDismiss={handleCloseDialog}
              onSave={() => {
                handleSave()
                refetch()
                handleActionThatChangesData()
              }}
              onNewCategory={handleNewCategory}
            />
          )}
          {isUnitDialogOpen && (
            <CreateUnitModal
              refetch={refetch}
              onDismiss={handleCloseUnitDialog}
              onSave={() => {
                handleUnitSave()
                refetch()
                handleActionThatChangesUnitData()
              }}
              onNewUnit={handleNewUnit}
            />
          )}
          <div className='card'>
            <div className='card-header'>
              <div className='card-title'>
                <h2>Informations</h2>
              </div>
            </div>
            <div className='card-body'>
              <div className='row'>
                <div className='col-12 col-sm-4'>
                  <label className='form-label required'>Libellé</label>
                  <Field
                    type='text'
                    name='label'
                    className='form-control form-control-solid'
                    placeholder='Intitule de product/service'
                  />
                  {touched.label && errors.label && (
                    <div className='text-danger'>{errors.label}</div>
                  )}
                </div>
                <div className='col-12 col-sm-4'>
                  <label className='form-label '>Catégorie</label>
                  <div className='d-flex flex-row align-items-center gap-2 '>
                    <div style={{width: '30vw'}} onClick={(e) => e.stopPropagation()}>
                      <Select
                        options={categoryOptions}
                        isLoading={categoriesLoading}
                        onChange={(selectedOption) => {
                          const newCategoryValue = newCategory
                            ? categoryOptions.find(
                                (category) => category.label === newCategory.name
                              )?.value
                            : selectedOption?.value

                          setFieldValue('category', newCategoryValue || '')
                        }}
                        // onChange={(selectedOption) => {
                        //   setFieldValue('category', selectedOption?.value || '')

                        // }}
                        value={categoryOptions?.find(
                          (option) =>
                            option.value ===
                            (newCategory
                              ? categoryOptions.find(
                                  (category) => category.label === newCategory.name
                                )?.value
                              : values?.category)
                        )}
                        // value={categoryOptions?.find((option) => option.value === values?.category)}
                        placeholder='Sélectionner catégorie'
                        isClearable
                      />
                      {touched.category && errors.category && (
                        <div className='text-danger'>{errors.category}</div>
                      )}
                    </div>
                    <button
                      type='button'
                      onClick={handleOpenDialog}
                      className='btn btn-light btn-active-light-primary mt-4 mt-sm-0'
                    >
                      <i className='fa-solid fa-plus' />
                    </button>
                  </div>
                </div>
                {sohwCurrency && (
                  <div className='col-12 col-sm-4'>
                    <label className='form-label'>Devise</label>
                    <div style={{width: '25vw'}} onClick={(e) => e.stopPropagation()}>
                      <Select
                        options={currenciesOptions}
                        onChange={(selectedOption) => {
                          setFieldValue('currency', selectedOption?.value || '')
                        }}
                        value={currenciesOptions?.find(
                          (option) => option.value === values.currency
                        )}
                        placeholder='Devise'
                        isClearable
                      />
                    </div>

                    {touched.currency && errors.currency && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{errors.currency}</div>
                      </div>
                    )}
                  </div>
                )}

                <div className='col-md-4 col-sm-4 mt-5'>
                  <label className='form-label'>Unité</label>
                  <div className='d-flex flex-row align-items-center gap-2 '>
                    <div style={{width: '30vw'}} onClick={(e) => e.stopPropagation()}>
                      <Select
                        options={unitOptions}
                        isLoading={unitsLoading}
                        onChange={(selectedOption) => {
                          const newUnitValue = newUnit
                            ? unitOptions.find((unit) => unit.label === newUnit.label)?.value
                            : selectedOption?.value

                          setFieldValue('unit', newUnitValue || '')
                        }}
                        // onChange={(selectedOption) => {
                        //   setFieldValue('unit', selectedOption?.value || '')
                        // }}
                        value={unitOptions?.find(
                          (option) =>
                            option.value ===
                            (newUnit
                              ? unitOptions.find((unit) => unit.label === newUnit.label)?.value
                              : values?.unit)
                        )}
                        // value={unitOptions?.find((option) => option.value === values.unit)}
                        placeholder='Sélectionner unité'
                        isClearable
                      />
                      {touched.unit && errors.unit && (
                        <div className='text-danger'>{errors.unit}</div>
                      )}
                    </div>

                    <button
                      type='button'
                      onClick={handleOpenUnitDialog}
                      className='btn btn-light btn-active-light-primary mt-4 mt-sm-0'
                    >
                      <i className='fa-solid fa-plus' />
                    </button>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-12 col-sm-12 mt-5'>
                  <label className='form-label'>Description</label>

                  <ReactQuill
                    value={values.description}
                    onChange={(value) => setFieldValue('description', value)}
                    // onKeyDown={checkCharacterCount}
                    ref={reactQuillRef}
                    modules={{
                      toolbar: [
                        [{header: [1, 2, 3, 4, 5, 6, false]}],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{color: []}, {background: []}],
                        [{align: []}],
                        ['link', 'image', 'video'],
                        ['clean'],
                      ],
                    }}
                    formats={[
                      'header',
                      'bold',
                      'italic',
                      'underline',
                      'strike',
                      'color',
                      'background',
                      'align',
                      'link',
                      'image',
                      'video',
                    ]}
                    placeholder={'Décrivez votre produit ici...'}
                  />
                  {/* {touched.description && errors.description && (
                    <div className='text-danger'>{errors.description}</div>
                  )} */}
                </div>
              </div>
            </div>
            <div className='card-header'>
              <div className='card-title'>
                <h2>Détails financiers</h2>
              </div>
            </div>
            <div className='d-flex flex-row'>
              <div className='card-body'>
                <div className='row d-flex flex-column align-items-start'>
                  <div className='row d-flex flex-column'>
                    <div className='col-8 col-sm-8'>
                      <label className='form-label'>Prix d'achat</label>
                      <div className='input-group input-group-solid'>
                        <Field
                          type='number'
                          name='price'
                          min={0}
                          className='form-control form-control-solid'
                          placeholder='Prix public'
                        />
                        <span className='input-group-text'>{currentUser?.company?.currency}</span>
                      </div>
                      <div style={{height: '24px'}}>
                        {touched.price && errors.price && (
                          <div className='text-danger'>{errors.price}</div>
                        )}
                      </div>
                    </div>
                    <div className='col-12 col-sm-3 d-flex justify-content-start align-items-end pt-5'>
                      <label className='form-check-label me-3'>HT </label>
                      <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                        <Field
                          type='checkbox'
                          name='check-color'
                          className='form-check-input'
                          checked={values?.priceType === 'TTC'}
                          // onChange={handleTaxAchatActiveToggle}
                          onChange={(e) => handleTaxAchatActiveToggle(e, setFieldValue)}
                        />
                        <label className='form-check-label ms-3'>TTC</label>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-8 pt-5'>
                    <div className='row align-items-center'>
                      <div className='col-6'>
                        <label className='form-label'>TVA 1</label>
                        <Field
                          type='number'
                          min='0'
                          max='100'
                          name='buyingTva'
                          // defaultValue={currentUser?.company?.tva}
                          className='form-control form-control-solid'
                          placeholder='Entrez TVA'
                        />
                        <div style={{height: '24px'}}>
                          {touched.buyingTva && errors.buyingTva && (
                            <div className='text-danger'>{errors.buyingTva}</div>
                          )}
                        </div>
                      </div>
                      {currentUser?.company?.country === 'TN' && (
                        <div className='col-6'>
                          <button
                            type='button'
                            onClick={toggleTva}
                            className='btn btn-light btn-active-light-primary mt-4 mt-sm-0'
                          >
                            {showTva ? (
                              <i className='fa-solid fa-minus' />
                            ) : (
                              <i className='fa-solid fa-plus' />
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                    {showTva && (
                      <>
                        <div className='row pt-3'>
                          <div className='col-6'>
                            <label className='form-label'>TVA 2</label>
                            <Field
                              type='number'
                              min='0'
                              name='buyingTvaTwo'
                              // defaultValue={currentUser?.company?.tvaTwo}
                              className='form-control form-control-solid'
                              placeholder='Entrez TVA'
                            />
                            <div style={{height: '24px'}}>
                              {touched.buyingTvaTwo && errors.buyingTvaTwo && (
                                <div className='text-danger'>{errors.buyingTvaTwo}</div>
                              )}
                            </div>
                          </div>
                          <div className='col-6'>
                            <label className='form-label'>TVA 3</label>
                            <Field
                              type='number'
                              min='0'
                              name='buyingTvaThree'
                              // defaultValue={currentUser?.company?.tvaThree}
                              className='form-control form-control-solid'
                              placeholder='Entrez TVA'
                            />
                            <div style={{height: '24px'}}>
                              {touched.buyingTvaThree && errors.buyingTvaThree && (
                                <div className='text-danger'>{errors.buyingTvaThree}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className='card-body'>
                <div className='row d-flex flex-column align-items-start'>
                  <div className='row d-flex flex-column'>
                    <div className='col-8 col-sm-8'>
                      <label className='form-label'>Prix de vente</label>
                      <div className='input-group input-group-solid'>
                        <Field
                          type='number'
                          name='sellPrice'
                          min={0}
                          className='form-control form-control-solid'
                          placeholder='Prix public'
                        />
                        <span className='input-group-text'>{currentUser?.company?.currency}</span>
                      </div>
                      <div style={{height: '24px'}}>
                        {touched.sellPrice && errors.sellPrice && (
                          <div className='text-danger'>{errors.sellPrice}</div>
                        )}
                      </div>
                    </div>
                    <div className='col-12 col-sm-3 d-flex justify-content-start align-items-end pt-5'>
                      <label className='form-check-label me-3 '> HT</label>
                      <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid '>
                        <Field
                          type='checkbox'
                          name='check-color'
                          className='form-check-input'
                          checked={values?.sellPriceType === 'TTC'}
                          // onChange={handleTaxActiveToggle}
                          onChange={(e) => handleTaxActiveToggle(e, setFieldValue)}
                          // onChange={(value) => setFieldValue('sellPriceType', taxActive)}
                        />
                      </div>
                      <label className='form-check-label ms-3'>TTC</label>
                    </div>
                  </div>
                  <div className='col-12 col-sm-8 pt-5'>
                    <div className='row align-items-center'>
                      <div className='col-6 col-sm-6'>
                        <label className='form-label'>TVA 1</label>
                        <Field
                          type='number'
                          min='0'
                          name='sellingTva'
                          // defaultValue={currentUser?.company?.tva}
                          className='form-control form-control-solid'
                          placeholder='Entrez TVA'
                        />
                        <div style={{height: '24px'}}>
                          {touched.sellingTva && errors.sellingTva && (
                            <div className='text-danger'>{errors.sellingTva}</div>
                          )}
                        </div>
                      </div>
                      {currentUser?.company?.country && (
                        <div className='col-3 col-sm-3'>
                          <button
                            type='button'
                            onClick={toggleTvaVente}
                            className='btn btn-light btn-active-light-primary mt-4 mt-sm-0'
                          >
                            {showTvaVente ? (
                              <i className='fa-solid fa-minus' />
                            ) : (
                              <i className='fa-solid fa-plus' />
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                    {showTvaVente && (
                      <>
                        <div className='row pt-3'>
                          <div className='col-6 col-sm-6 '>
                            <label className='form-label'>TVA 2</label>
                            <Field
                              type='number'
                              min='0'
                              name='sellingTvaTwo'
                              className='form-control form-control-solid'
                              // defaultValue={currentUser?.company?.tvaTwo}
                              placeholder='Entrez TVA'
                            />
                            <div style={{height: '24px'}}>
                              {touched.sellingTvaTwo && errors.sellingTvaTwo && (
                                <div className='text-danger'>{errors.sellingTvaTwo}</div>
                              )}
                            </div>
                          </div>
                          <div className='col-6 col-sm-6'>
                            <label className='form-label '>TVA 3</label>
                            <Field
                              type='number'
                              min='0'
                              name='sellingTvaThree'
                              // defaultValue={currentUser?.company?.tvaThree}
                              className='form-control form-control-solid'
                              placeholder='Entrez TVA'
                            />
                            <div style={{height: '24px'}}>
                              {touched.sellingTvaThree && errors.sellingTvaThree && (
                                <div className='text-danger'>{errors.sellingTvaThree}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='card-header'>
              <div className='card-title'>
                <h2>Plus de détails</h2>
              </div>
            </div>
            <div className='card-body'>
              <div className='row mb-2'>
                <div className='col-4 col-sm-2 mt-2 d-flex justify-content-start align-items-center'>
                  <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                    <Field
                      type='checkbox'
                      name='check-color'
                      className='form-check-input'
                      checked={colorActive}
                      onChange={() => handleColorToggle()}
                    />
                    <label className='form-check-label'>Couleur</label>
                  </div>
                </div>
              </div>
              <div className='row mb-5'>
                {colorActive && (
                  <div className='col-12 col-sm-3 mt-2'>
                    <label className='form-label'>Couleur</label>
                    <div className='d-flex justify-content-start'>
                      <div className='col-6'>
                        <Field
                          name='color'
                          className='form-control d mb-3 mb-lg-0'
                          type='color'
                          min={0}
                          max={100}
                        />
                        {touched.color && errors.color && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{errors.color}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className='row'>
                <div className='col-12 col-sm-3'>
                  <label className='form-label text-success'>Stock maximum</label>
                  <Field
                    type='number'
                    name='maxStock'
                    className='form-control form-control-solid'
                  />
                  {touched.maxStock && errors.maxStock && (
                    <div className='text-danger'>{errors.maxStock}</div>
                  )}
                </div>
                <div className='col-12 col-sm-3'>
                  <label className='form-label text-danger'>Stock minimum</label>

                  <Field
                    type='number'
                    name='minStock'
                    className='form-control form-control-solid'
                  />
                  {touched.minStock && errors.minStock && (
                    <div className='text-danger'>{errors.minStock}</div>
                  )}
                </div>

                <div className='col-12 col-sm-3'>
                  <label className='form-label'>Code à barre</label>

                  <Field
                    type='text'
                    name='barCode'
                    className='form-control form-control-solid'
                    placeholder='code à barre'
                  />
                  {touched.barCode && errors.barCode && (
                    <div className='text-danger'>{errors.barCode}</div>
                  )}
                </div>
              </div>

              <div className='row'>
                <div className='col'>
                  <div className='form-check form-check-sm mt-4'>
                    <Field
                      type='checkbox'
                      name='allowManufactureEmpty'
                      className='form-check-input'
                      id='flexCheckDefault'
                      checked={values.allowManufactureEmpty}
                      onChange={(event) => {
                        const isChecked = event.target.checked
                        // setAllowManufactureEmpty(isChecked)
                        setFieldValue('allowManufactureEmpty', isChecked)
                      }}
                    />
                    <label className='form-check-label' htmlFor='flexCheckDefault'>
                      Permettre la vente même si le stock est vide
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer text-end'>
              <button
                onClick={() => {
                  handleSubmit(values)
                }}
                type='submit'
                className='btn btn-sm btn-primary me-3'
                disabled={isSubmitting}
              >
                {isSubmitting ? 'En cours...' : 'Enregistrer'}
              </button>
              <button type='reset' className='btn btn-sm btn-danger' onClick={handleGoBack}>
                Annuler
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

const ProductCreate: FC = () => {
  const {id} = useParams()

  const {
    data: productData,
    refetch,
    isLoading: productDataLoading,
    isSuccess: productDataSuccess,
  } = useQuery(
    `product-${id}`, // Unique query key based on productId
    () => getProductById(Number(id)), // Fetch product data based on productId
    {
      enabled: !!id, // Enable query only when productId is available
    }
  )
  const refetchProduct = refetch || (() => {})

  if (productDataLoading)
    <div className='d-flex justify-content-center align-items-center' style={{height: '75vh'}}>
      <div className='spinner-border text-primary' role='status'>
        <span className='visually-hidden'>Chargement...</span>
      </div>
    </div>
  if (productDataLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{height: '75vh'}}>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Chargement...</span>
        </div>
      </div>
    )
  } else if (productDataSuccess) {
    return <ProductForm productForUpdate={productData} refetchProduct={refetchProduct} />
  } else {
    return <ProductForm />
  }
}

export default ProductCreate
